export default __webpack_public_path__ + "static/media/placeholder-special-featured.b25b2c81.svg";